module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'customers',
        preventClearOnCancel: true,
        updateTabTitleForFieldCodes: {
            companyName: true
        },
        updateTabTitleTabContentLocator: '<< base_tabStrip_tabContent',
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_customers': true,
        },
    },
}